$(function () {
  var headerHight = 0; //ヘッダの高さ
  $("a[href^='#']").on("click", function () {
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    var position = target.offset().top - headerHight; //ヘッダの高さ分位置をずらす
    $("html, body").animate({ scrollTop: position }, 500, "swing");
    return false;
  });
  //////////////////////////////////////////////
  //ハンバーガーメニュー
  //////////////////////////////////////////////
  let humberger = $("#js-humberger");
  let headerNav = $(".p-header__nav");
  const humbergerClass = "js-menu-active";
  var state = false;
  var scrollpos;
  $("#js-humberger").on("click", function () {
    headerNav.toggleClass(humbergerClass);
    humberger.toggleClass(humbergerClass);
    if (humberger.attr("aria-expanded") == "false") {
      humberger.attr("aria-expanded", true);
    } else {
      humberger.attr("aria-expanded", false);
    }
    if (state == false) {
      scrollpos = $(window).scrollTop();
      $("body").addClass("fixed").css({ top: -scrollpos });
      state = true;
    } else {
      $("body").removeClass("fixed").css({ top: 0 });
      window.scrollTo(0, scrollpos);
      state = false;
    }
  });

  //可視領域に入ったらハンバーガーメニューを表示

  //////////////////////////////////////////////
  //ハンバーガーメニュー（求人）
  //////////////////////////////////////////////
  let recruitHumberger = $("#js-recruit-humberger");
  let recruitHeaderNav = $(".p-recruit-header__nav");
  const recruitHumbergerClass = "js-recruit-menu-active";

  $("#js-recruit-humberger").on("click", function () {
    recruitHeaderNav.toggleClass(recruitHumbergerClass);
    recruitHumberger.toggleClass(recruitHumbergerClass);
    if (recruitHumberger.attr("aria-expanded") == "false") {
      recruitHumberger.attr("aria-expanded", true);
    } else {
      recruitHumberger.attr("aria-expanded", false);
    }
    if (state == false) {
      scrollpos = $(window).scrollTop();
      $("body").addClass("fixed").css({ top: -scrollpos });
      state = true;
    } else {
      $("body").removeClass("fixed").css({ top: 0 });
      window.scrollTo(0, scrollpos);
      state = false;
    }
  });

  $("#js-recruit-nav .js-link").on("click", function () {
    recruitHeaderNav.removeClass(recruitHumbergerClass);
    recruitHumberger.removeClass(recruitHumbergerClass);
    recruitHumberger.attr("aria-expanded", false);
    $("body").removeClass("fixed").css({ top: 0 });
    window.scrollTo(0, scrollpos);
    state = false;
  });

  //////////////////////////////////////////////
  //nav acordion - PC only
  //////////////////////////////////////////////
  if (window.matchMedia("(min-width:1180px)").matches) {
    $(".js-nav-click").on("click", function () {
      $(".nav-inner").slideToggle(300);
      $(this).toggleClass("js-nav-inner-open");
      return false;
    });
  }

  //////////////////////////////////////////////
  //スクロール
  //////////////////////////////////////////////
  let recruitHeader = $(".p-recruit-header");
  $(window).on("scroll", function () {
    if ($(this).scrollTop() > 100) {
      recruitHeader.addClass("js-recruit-header-active");
    } else {
      recruitHeader.removeClass("js-recruit-header-active");
    }
  });

  //////////////////////////////////////////////
  //tab
  //////////////////////////////////////////////
  let tab = $(".js-tab");
  let panel = $(".js-panel");
  const tabClass = "js-tab-active";
  tab.on("click", function () {
    tab.removeClass(tabClass).attr("aria-selected", "false").attr("tabindex", "-1");
    panel.removeClass(tabClass);
    $(this).addClass(tabClass).attr("aria-selected", "true").attr("tabindex", "0");
    var index = tab.index(this);
    panel.eq(index).addClass(tabClass);
  });

  //////////////////////////////////////////////
  //lighth box風
  //////////////////////////////////////////////
  const modal = $("#modal-container");
  const img = modal.find("img");

  $("img.popup").each(function (index) {
    $(this).on("click", function () {
      img.attr("src", $(this).attr("src"));
      modal.fadeIn();
    });
  });

  modal.on("click", function () {
    $(this).fadeOut();
  });
  $(".modal-close-btn").on("click", function () {
    modal.fadeOut();
  });

  //////////////////////////////////////////////
  //目次
  //////////////////////////////////////////////

  var idcount = 1;
  var toc = "";
  var ht_arr = [];
  var a_arr = [];
  $(".c-post-style :header", this).each(function () {
    this.id = "toc_" + idcount;
    idcount++;
    if (this.nodeName.toLowerCase() == "h2") {
      ht_arr.push(2);
    } else if (this.nodeName.toLowerCase() == "h3") {
      ht_arr.push(3);
    } else if (this.nodeName.toLowerCase() == "h4") {
      ht_arr.push(4);
    } else if (this.nodeName.toLowerCase() == "h5") {
      ht_arr.push(5);
    } else if (this.nodeName.toLowerCase() == "h6") {
      ht_arr.push(6);
    }

    var a = '<a href="#' + this.id + '">' + $(this).text() + "</a>";
    a_arr.push(a);
  });

  toc += "<ul class='chapter'>";
  for (var i = 0; i + 1 < ht_arr.length; ++i) {
    if (ht_arr[i] == ht_arr[i + 1]) {
      toc += "<li>" + a_arr[i] + "</li>";
    } else if (ht_arr[i] < ht_arr[i + 1]) {
      toc += "<li>" + a_arr[i] + "<ul>";
    } else if (ht_arr[i] > ht_arr[i + 1]) {
      toc += "<li>" + a_arr[i] + "</li>";
      var ulli_num = ht_arr[i] - ht_arr[i + 1];
      for (var j = 0; j < ulli_num; ++j) {
        toc += "</ul></li>";
      }
    }
  }

  //最後の1つと</ul></li>の数合わせ
  toc += "<li>" + a_arr[ht_arr.length - 1] + "</li>";
  var ulli_num = ht_arr[ht_arr.length - 1] - 2;
  for (var j = 0; j < ulli_num; ++j) {
    toc += "</ul></li>";
  }
  toc += "</ul>";

  if (toc) {
    toc = '<div class="c-post-style__toc"><div class="c-post-style__toc-title">目次</div>' + toc + "</div>";
  }
  $("#toc").html(toc);

  //ページ内リンク#非表示。加速スクロール
  var headerHight = 0; //ヘッダの高さ
  $("a[href^='#']").on("click", function () {
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    var position = target.offset().top - headerHight; //ヘッダの高さ分位置をずらす
    $("html, body").animate({ scrollTop: position }, 500, "swing");
    return false;
  });
});
